<template>
  <v-container fluid class="work-order-detail" v-if="workOrder">
    <v-row class="flex-grow-0">
      <v-btn text
             x-small
             color="primary"
             exact
             :to="{name: 'contract-work-orders', params: {contractId: workOrder.contract.id}}">
        &lt;&lt; {{ workOrder.contract.name }}
      </v-btn>
    </v-row>

    <v-row class="work-order-info-wrapper">
      <v-col cols="12">
        <div class="work-order-info">
          <h3>[{{ workOrder.work_order_no }}] {{ workOrder.name }}</h3>
          <div v-if="workOrder.admin">
            W.O. Admin: {{ workOrder.admin.name }} ({{ workOrder.admin.post }})
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row class="d-flex flex-grow-1">
      <DimBookInput :work-order-id="$route.params.workOrderId"></DimBookInput>
    </v-row>
  </v-container>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api/dist/vue-composition-api";
import {ACTION_TYPES} from "@/store/types";
import DimBookInput from "@/components/dimbook/DimBookInput";

export default {
  name: 'WorkOrder',
  components: {DimBookInput},
  setup(props, {root}) {
    const workOrder = ref(null);
    const getWorkOrder = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/work_order/',
        params: {work_order_id: root.$route.params.workOrderId},
      });

      if (response.body.success) {
        workOrder.value = response.body.work_order;

        await getDimBook();
      }
    }

    const currentDimBook = ref(null);
    const dimbooks = ref([]);

    const getDimBook = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/dimbook/',
        params: {
          work_order_id: root.$route.params.workOrderId,
        }
      });

      if (response.body.success) {
        currentDimBook.value = _.last(response.body.dimbooks);
        dimbooks.value = response.body.dimbooks;
      }
    }

    onMounted(() => {
      getWorkOrder();
    })

    return {
      workOrder,
      currentDimBook,
      dimbooks,
    }
  },
}
</script>

<style lang="less">
.work-order-detail {
  display: flex;
  flex-direction: column;

  .work-order-info-wrapper {
    flex: 0 0 auto;
  }

  .work-order-row {
    flex: 0 0 auto;
  }
}
</style>
